
export const root = {
    borderRadius: '{content.border.radius}'
};

export default {
    root
};
